'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/quick-quote/index.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _accesibility = require('@marmalade/accesibility');
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _grid = require('@marmalade/grid');
var _actions = require('@marmalade/ldi/lib/quote/actions');
var _selectors = require('@marmalade/ldi/lib/quote/selectors');
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _panel = require('@marmalade/panel');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reduxWindow = require('redux-window');
var _guid = require('../../guid');
var _guid2 = _interopRequireDefault(_guid);
var _cover = require('./cover');
var _cover2 = _interopRequireDefault(_cover);
var _fdiCover = require('./fdi-cover');
var _fdiCover2 = _interopRequireDefault(_fdiCover);
var _form = require('./form');
var _form2 = _interopRequireDefault(_form);
var _usps = require('./usps');
var _usps2 = _interopRequireDefault(_usps);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var contentStyles = function contentStyles(_ref) {
  var mobile = _ref.mobile,
    theme = _ref.theme;
  return {
    display: 'flex',
    flexDirection: mobile ? 'column' : 'row-reverse',
    alignItems: 'flex-start',
    marginBottom: theme.space_md
  };
};
var Content = (0, _glamorous2.default)('div')(contentStyles);
var QuickQuote = function (_Component) {
  _inherits(QuickQuote, _Component);
  function QuickQuote() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck(this, QuickQuote);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = QuickQuote.__proto__ || Object.getPrototypeOf(QuickQuote)).call.apply(_ref2, [this].concat(args))), _this), _this.clearQuotes = function (e) {
      (0, _accesibility.Select)(function () {
        return _this.props.clearQuotes();
      })(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(QuickQuote, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var mobile = this.props.width < this.props.theme.breakpoint_md;
      var Element = this.props.container ? _grid.Container : _react.Fragment;
      var Wrapper = function Wrapper(_ref3) {
        var children = _ref3.children;
        return _react2.default.createElement(Element, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 50
          },
          __self: _this2
        }, _react2.default.createElement('h1', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51
          },
          __self: _this2
        }, 'Learner Driver Insurance'), _react2.default.createElement(Content, {
          mobile: mobile,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 52
          },
          __self: _this2
        }, _react2.default.createElement(_panel.Panel, {
          css: {
            width: '100%',
            minWidth: mobile ? 'auto' : '500px',
            maxWidth: mobile ? '500px' : 'auto',
            marginLeft: mobile ? 'auto' : '50px',
            marginRight: mobile ? 'auto' : 0
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 53
          },
          __self: _this2
        }, _react2.default.createElement('h2', {
          style: {
            textAlign: 'center'
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 62
          },
          __self: _this2
        }, _this2.props.quoted ? 'Your' : 'Get a', ' quote'), children, _this2.props.quoted && _react2.default.createElement(_react.Fragment, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 65
          },
          __self: _this2
        }, _react2.default.createElement('a', {
          onClick: _this2.clearQuotes,
          onKeyDown: _this2.clearQuotes,
          role: 'button',
          tabIndex: 0,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 66
          },
          __self: _this2
        }, 'Get a new quote'), _react2.default.createElement('p', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 69
          },
          __self: _this2
        }, 'Price includes Insurance Premium Tax and an administration fee'), _react2.default.createElement('p', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 70
          },
          __self: _this2
        }, '*Indicative quote based on a non-electric vehicle and less than 20 years old'))), _react2.default.createElement(_usps2.default, {
          themeName: _this2.props.theme.name || '',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 74
          },
          __self: _this2
        })), _this2.props.theme.fdiQuickQuote && _react2.default.createElement(_fdiCover2.default, {
          guid: _this2.props.guid,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 76
          },
          __self: _this2
        }));
      };
      if (this.props.fetching) {
        return _react2.default.createElement(Wrapper, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 81
          },
          __self: this
        }, _react2.default.createElement(_loading2.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          },
          __self: this
        }));
      }
      if (this.props.requestError || this.props.quoteError) {
        return _react2.default.createElement(Wrapper, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 88
          },
          __self: this
        }, _react2.default.createElement(_react.Fragment, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 89
          },
          __self: this
        }, _react2.default.createElement('p', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 90
          },
          __self: this
        }, 'Sorry, something went wrong.'), _react2.default.createElement(_button2.default, {
          prominence: 'primary',
          text: 'Try again',
          onClick: this.props.clearQuotes,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 91
          },
          __self: this
        })));
      }
      return _react2.default.createElement(Wrapper, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97
        },
        __self: this
      }, this.props.quoted ? _react2.default.createElement(_cover2.default, {
        fdiQuickQuote: this.props.theme.fdiQuickQuote,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 99
        },
        __self: this
      }) : _react2.default.createElement(_form2.default, {
        fdiQuickQuote: this.props.theme.fdiQuickQuote,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101
        },
        __self: this
      }));
    }
  }]);
  return QuickQuote;
}(_react.Component);
QuickQuote.propTypes = {
  container: _propTypes.bool.isRequired,
  // STP - quote info
  fetching: _propTypes.bool.isRequired,
  quoteError: _propTypes.bool.isRequired,
  requestError: _propTypes.bool.isRequired,
  quoted: _propTypes.bool.isRequired,
  width: _propTypes.number.isRequired,
  theme: _propTypes.object.isRequired,
  // DTP
  clearQuotes: _propTypes.func.isRequired
};
exports.default = (0, _glamorous.withTheme)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    quoteError: (0, _selectors.getQuoteInfo)(state).quoteError,
    requestError: (0, _selectors.getQuoteInfo)(state).requestError,
    quoted: (0, _selectors.hasQuoted)(state),
    fetching: (0, _selectors.getQuoteInfo)(state).fetching,
    width: (0, _reduxWindow.getWidth)(state),
    guid: (0, _guid2.default)(state, ownProps.theme)
  };
}, {
  clearQuotes: _actions.clearQuotes
})(QuickQuote));